import { DeliveryMethod } from "../constants";
import { TOffersResponse } from "../models/offers";
import type { TOffer, TCoupon, TOffersResult, TOffersParams } from "../types";

const mapOffersResponse = (response: TOffersResponse, params: TOffersParams): TOffersResult => {
  const offers: TOffer[] = (response.offers || []).map((offer) => ({
    deliveryMethod: offer.serviceType as DeliveryMethod,
    priceGroupId: offer.priceGroupId,
    params,
    price: offer.price,
    ...(offer.originalPrice && { originalPrice: offer.originalPrice }),
    ...(offer.notification && { notification: offer.notification }),
    ...(offer.serviceDuration && { serviceDuration: offer.serviceDuration }),
  }));
  const coupon: TCoupon | null = response.coupon && {
    isValid: response.coupon.isValid,
    promoCode: response.coupon.code || null,
    isBlocked: !!response.coupon.blocked || !!response.coupon.isLimitedByUser,
  };
  return { isSuccess: true, offers, coupon, marketingConsent: response.marketingConsent };
};
export default mapOffersResponse;
